import { Text } from "@overmap-ai/blocks"
import { type IssueTypeIdentifierValue, type Stored, UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import { selectIssueById, selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { IssueTypeIcon } from "../Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../IndexLabels/IssueIndex"
import { ProjectTimelineCard } from "./ProjectTimelineCard"
import { getTimelineDate } from "./utils"

interface ProjectTimelineIssueIdentifierValueItemProps {
	issueTypeIdentifierValue: Stored<IssueTypeIdentifierValue>
}

export const ProjectTimelineIssueIdentifierValueItem = memo<ProjectTimelineIssueIdentifierValueItemProps>((props) => {
	const { issueTypeIdentifierValue } = props
	const actor = useAppSelector(selectUserById(issueTypeIdentifierValue.created_by ?? -1))
	const issue = useAppSelector(selectIssueById(issueTypeIdentifierValue.issue))!

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ISSUE_IDENTIFIER_VALUE}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(actor)}</Text>
				&nbsp;updated an identifier value for issue&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/issues/$issueId"
					params={{ issueId: issue.uuid }}
				>
					<Text highContrast className={interactiveTextCva()}>
						<IssueTypeIcon className="align-sub" issueTypeId={issue.issue_type} />
						&nbsp;
						<IssueIndexLabel issueId={issue.uuid} highContrast />
						<Text accentColor="base">&nbsp;{issue.title || UNTITLED_ISSUE_TITLE}</Text>
					</Text>
				</Link>
				<Text accentColor="base">
					&nbsp;&#8226;&nbsp;{formatCompactDate(getTimelineDate(issueTypeIdentifierValue))}
				</Text>
			</Text>

			<Text size="sm" accentColor="base" className="min-w-0 truncate">
				{issueTypeIdentifierValue.value}
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineIssueIdentifierValueItem.displayName = "ProjectTimelineIssueIdentifierValueItem"
